/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { menuItems } from "./menuItems";
import { isAuthenticated, userDetails } from "../../utils";
import { DistributorMenu } from "./DistributorMenu";
import { UserMenu } from "./UserMenu";
const Navigation = ({ isOpen, currentRoute }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userDate, setUserDate] = useState();
  const [activeLiIndex, setActiveLiIndex] = useState(null);

  useEffect(() => {
    setUserDate(userDetails());
  }, [isAuthenticated()]);

  const LogOut = () => {
    sessionStorage.removeItem("token", { path: "/" });
    sessionStorage.removeItem("agentDetails", { path: "/" });
    sessionStorage.removeItem("userDetails", { path: "/" });
    sessionStorage.removeItem("agentData", { path: "/" });
    sessionStorage.removeItem("userdata", { path: "/" });
    localStorage.removeItem("agentData");
    localStorage.removeItem("userdata");
    navigate("/");
  };

  // Select the appropriate menu based on user role
  const selectedMenuItems =
    ["Super Distributor", "Super Manager", "Manager"].includes(
      userDate?.role
    ) ||
    (userDate?.role === "Partner" && userDate?.createdBy?.startsWith("GK00400"))
      ? menuItems
      : userDate?.role === "Distributor"
      ? DistributorMenu
      : userDate?.role === "Partner" &&
        !userDate?.createdBy?.startsWith("GK00400")
      ? DistributorMenu
      : userDate?.role === "User"
      ? UserMenu
      : [];

  return (
    <nav>
      <ul className={`toresponsive ${isOpen ? "show" : ""}`}>
        {selectedMenuItems.map((item, index) => (
          <li
            key={index}
            style={{
              backgroundColor:
                activeLiIndex === index ? "#20b7c9" : "transparent",
            }}
            onClick={() => setActiveLiIndex(index)}
          >
            <a
              className={
                location.pathname === item.path
                  ? "child-active main_a a_pointer"
                  : "main_a a_pointer"
              }
              href={item.path || "/"}
              onClick={(e) => {
                e.stopPropagation(); // prevents li's click handler
                setActiveLiIndex(null);
              }}
            >
              {item.title}
            </a>

            {!item.isSingle && (
              <ul>
                {item.subItems.map((subItem, subIndex) => (
                  <li key={subIndex} onClick={() => setActiveLiIndex(index)}>
                    <a
                      className={`a_pointer ${
                        location.pathname === subItem.path ? "child-active" : ""
                      }`}
                      href={subItem.path}
                      onClick={(e) => {
                        e.stopPropagation(); // prevents li's click handler
                        setActiveLiIndex(null);
                      }}
                    >
                      {subItem.title}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
        <li>
          <a
            className="main_a a_pointer logOut_bottom_btn"
            onClick={() => LogOut()}
          >
            LogOut
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Navigation;
